<div class="search-box" [class.show]="isOpen" (clickOutside)="outSideClose()">
    <span class="material-icons search-icon">search</span>
   <input type="search" class="form-control search-type" placeholder="Rechercher une célébrité..." (click)="isOpen = true" (focus)="isOpen = true" [formControl]="TopSearchControl">
   
   @if (isOpen) {
   <div class="search-suggestion" style="z-index: 1000;">
       @if (isLoading) {
        <div class="d-flex justify-content-center align-items-center py-4">
            <div class="spinner-border text-primary" role="status" style="width: 2rem; height: 2rem;">
                <span class="visually-hidden">Chargement...</span>
            </div>
        </div>
       } @else {
            @if (filteredData.length > 0) {
            <span class="recent">Recherche célébrités</span>
            <ul class="friend-list">
                @for (item of filteredData; track item) {
                        <li (click)="isOpen = false">
                            <a [routerLink]="['/profile/celebrity', item.id]" [queryParamsHandling]="'merge'" [routerLinkActive]="'active'">
                                <div class="media">
                                    <img [src]="item.profile_picture || 'assets/images/avatar.jpeg'" alt="user">
                                    <div class="media-body">
                                        <div>
                                            <h5 class="mt-0">{{ item.scene_name }}</h5>
                                            <!-- <h6> 1 mutual friend</h6> -->
                                        </div>
                                    </div>
                                </div>
                            </a>                
                        </li>
                    }
            </ul>
            } @else {
                <div class="text-center py-4 text-muted">
                    @if (TopSearchControl.value && TopSearchControl.value.length > 3) {
                       <p class="mb-0">Aucun résultat trouvé</p>
                    } @else {
                        <p class="mb-0">Veuillez saisir le nom d'une célébrité</p>
                    }
                </div>
            }
       }
   </div>
   }
</div>